import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { Slider } from "../components/ui/slider"

export function SliderRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent } = useRenderContext()

  const min = element.variant ? Number(resolveSymbol(element.variant) ?? 0) : 0
  const max = element.size ? Number(resolveSymbol(element.size) ?? 100) : 100

  const handleValueChange = (value: number[]) => {
    dispatchEvent(element.id, "change", { value: value[0] })
  }

  return (
    <div className={element.className} data-testid={`slider-${element.id}`}>
      <Slider id={element.id} min={min} max={max} onValueChange={handleValueChange} />
    </div>
  )
}
